<span class="icon-wrapper"
  #tooltipRef
  [wsTooltip]="tooltipText"
  [wsTooltipDisabled]="!tooltipText"
  [wsTooltipShowDelay]="200"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <!-- Show custom content if provided and it's not just a mat-icon, otherwise show help icon -->
  <ng-container *ngIf="hasContent; else iconTemplate">
    <ng-content></ng-content>
  </ng-container>
  
  <!-- Icon template (fallback) - always show help_outline by default -->
  <ng-template #iconTemplate>
    <mat-icon
      #iconRef
      [style.display]="!showIcon ? 'none' : null"
      class="scale85"
      [style]="iconOverrides"
      >help_outline</mat-icon
    >
  </ng-template>
</span>
